"use strict";

exports.__esModule = true;
exports.OpenReportUserAction = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _OpenReportActionElement = require("./OpenReportActionElement");
var _OpenReportActionFields = require("./OpenReportActionFields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var OpenReportUserAction = exports.OpenReportUserAction = {
  name: "OpenReport",
  icon: "link",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "OpenReportUserActionDefinition.label",
    defaultMessage: "Open Report"
  }),
  description: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "OpenReportForParticularDeviceUserActionDefinition.label",
    defaultMessage: "Opens the report page for a particular device."
  }),
  requiresContexts: ["device"],
  requiresProps: ["reportID"],
  components: {
    Element: _OpenReportActionElement.OpenReportActionElement,
    Fields: _OpenReportActionFields.OpenReportActionFields
  }
};